import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoBusqueda } from 'src/app/pages/configuracion/Envios/envios/models/tipo-busqueda';
import { TipoDestinatario } from 'src/app/pages/configuracion/Envios/envios/models/tipo-destinatario';
import { TipoEnvio } from 'src/app/pages/configuracion/Envios/envios/models/tipo-envio';
import { TipoFirmante } from 'src/app/pages/configuracion/Envios/envios/models/tipo-firmante';
import { TipoMail } from 'src/app/pages/configuracion/Envios/envios/models/tipo-mail';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';
import { EndpointService } from 'src/app/shared/services/endpoint.service';
import { IGestionarTiposEnvioService } from './ports/igestionar-tipos-envio-service';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { FiltroEnvio } from 'src/app/shared/models/filtros';


@Injectable({
  providedIn: 'root'
})

export class RecuperaTipoEnvioApiService implements IGestionarTiposEnvioService {

  private readonly URL_GET_TIPOS_ENVIO: string = this.endpointService.UrlGetTipoEnvio;
  private readonly URL_GET_TIPO_FIRMANTES: string = this.endpointService.UrlGetTipoFirmantes;
  private readonly URL_GET_TIPO_BUSQUEDAS: string = this.endpointService.UrlGetTipoBusquedas;
  private readonly URL_GET_TIPO_DESTINATARIOS: string = this.endpointService.UrlGetTipoDestinatarios;
  private readonly URL_GET_TIPO_MAILS: string = this.endpointService.UrlGetTipoDirecciones;
  private readonly URL_ALTA_TIPO_ENVIO: string = this.endpointService.UrlAltaTipoEnvio;
  private readonly URL_GET_TIPO_ENVIO_ID: string = this.endpointService.UrlGetTipoEnvioId;

  constructor(private client: HttpClient,
              private loginService: LoginService,
              private endpointService: EndpointService,
              private conversionDatosApiService: ConversionDatosApiService) { }

  envios: any[];
  envioObject: TipoEnvio;
  mails: TipoMail[];
  firmantes: TipoFirmante[];
  busquedas: TipoBusqueda[];
  destinatarios: TipoDestinatario[];

   async getTipoEnvios(
     filtrosEnvio: FiltroEnvio[],
     pageNumber:number,
     pageSize:number = 200,
     orden: OrdenColumna = {campoOrden:'', orden:''},
     incluirEnvioSimple: boolean = false
   ): Promise<void>{

    let pageSizeParam:number = pageNumber==0 ? 0 : 200;
    let pageNumberParam:number = pageNumber==0 ? 0 : pageNumber;
    let estado = filtrosEnvio.find(x=>x.text=='Estado')?.value
    let filtroBuscar = filtrosEnvio.find(x=>x.text=='Texto')?.value;

    let params = new HttpParams()
      .set('pageNumber', pageNumberParam)
      .set('pageSize', pageSizeParam)
      .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')

    if (incluirEnvioSimple) {
      params = params.set('incluirEnvioSimple', 'true');
    }

    if (estado === 'Incompleto') {
      params = params.set('filtros[ESTADO]', 'Incompleto');
    } else if (estado === 'Listo para envío') {
      params = params.set('filtros[ESTADO]', 'Completo');
    }

    if(orden.campoOrden &&orden.campoOrden == 'tiposDocumento'){
      params = params.set('orden[NUMDOCENVIAR]', orden.orden);
    }else if (orden.campoOrden) {
      params = params.set(`orden[${orden.campoOrden.toUpperCase()}]`, orden.orden);
    }

    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      }),
      params: params
    };


    await this.client.get(this.URL_GET_TIPOS_ENVIO, options).pipe(
      map((response: any) =>{
        if (response) {
          this.envios = this.conversionDatosApiService.mapEnviosEntrada(response);
          this.envios = this.conversionDatosApiService.convertir0ANull(this.envios);

          this.envios.forEach(x => {
            if(x.tiposDocumento.length == 0) x.activo = false;
            x.mailPrincipal = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(x.mailPrincipal);
            x.ordenMail = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(x.ordenMail);
            x.ordenTelefonoSMS = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(x.ordenTelefonoSMS);
            x.ordenTelefonoOTP = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(x.ordenTelefonoOTP);
            x.firmantes.map((y:any) => {
              y.tipoBusqueda = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(y.tipoBusqueda)
              y.tipoDestinatario = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(y.tipoDestinatario)
              y.tipoFirmante = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(y.tipoFirmante)
            })
            //le damos el valor de mailPrincipal a ordenMail para salvar los dosieres angiguos que no tienen esta opción. Esto pasa en los creados antes de añadir el envío por SMS.

            if(x.mailPrincipal!==null && x.ordenMail==null) x.ordenMail=x.mailPrincipal;
          })

        } else throw new Error(response);
      })
    ).toPromise();
  }

  guardaEnvio(data:any): Observable<void> {
    let firmantes = this.conversionDatosApiService.mapFirmantesSalida(data.firmantes);
    let dataEnvio = this.conversionDatosApiService.mapEnviosSalida(data);
    dataEnvio.Firmantes = firmantes;
    dataEnvio.Firmantes.map((x:any) => {
      x.TipoBusqueda = this.conversionDatosApiService.mapTiposEnvioDesplegablesSalida(x.TipoBusqueda)
      x.TipoDestinatario = this.conversionDatosApiService.mapTiposEnvioDesplegablesSalida(x.TipoDestinatario)
      x.TipoFirmante = this.conversionDatosApiService.mapTiposEnvioDesplegablesSalida(x.TipoFirmante)
    })
    dataEnvio.OrdenMail = this.conversionDatosApiService.mapTiposEnvioDesplegablesSalida(dataEnvio.OrdenMail)
    dataEnvio.OrdenTelefonoSms = this.conversionDatosApiService.mapTiposEnvioDesplegablesSalida(dataEnvio.OrdenTelefonoSms)
    dataEnvio.OrdenTelefonoOTP = this.conversionDatosApiService.mapTiposEnvioDesplegablesSalida(dataEnvio.OrdenTelefonoOTP)

    dataEnvio.TiposDocumento = dataEnvio.TiposDocumento.map(doc=>{
      doc = this.conversionDatosApiService.mapDocumentosSalida(doc);
      if(doc.FirmantesNif?.length>0){
        doc.FirmantesNif = this.conversionDatosApiService.mapFirmantesNifSalida(doc.FirmantesNif);
      }
      return doc
    })

    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.post<void>(this.URL_ALTA_TIPO_ENVIO, dataEnvio, options);
  }

  getTipoFirmante():Observable<TipoFirmante[]> {
      const options = {
        headers: new HttpHeaders({
          'Content-Type':'application/json',
          'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
        })
      };
      return this.client.get(this.URL_GET_TIPO_FIRMANTES, options).pipe(
        map((response: any) =>{
          if (response) {
            let firmantes: TipoFirmante[]  = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntrada(response)
            this.firmantes = firmantes;
            return firmantes;
          }
          else throw new Error(response);
        })
      );
  }

  getTipoBusqueda(): Observable<TipoBusqueda[]> {
    if(this.busquedas){
      return of(this.busquedas)
    }else{
      const options = {
        headers: new HttpHeaders({
          'Content-Type':'application/json',
          'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
        })
      };
      return this.client.get(this.URL_GET_TIPO_BUSQUEDAS, options).pipe(
        map((response: any) =>{
          if (response) {
            let busquedas: TipoBusqueda[] = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntrada(response)
            busquedas.unshift({codigo:'', desc:''});
            this.busquedas = busquedas;
            return busquedas;
          }
          else throw new Error(response);
        })
      );
    }

  }

  getTipoDestinatario(): Observable<TipoDestinatario[]> {
    if(this.destinatarios){
      return of(this.destinatarios)
    }else{
      const options = {
        headers: new HttpHeaders({
          'Content-Type':'application/json',
          'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
        })
      };
      return this.client.get(this.URL_GET_TIPO_DESTINATARIOS, options).pipe(
        map((response: any) =>{
          if (response) {
            let destinatarios: TipoDestinatario[] = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntrada(response)
            this.destinatarios = destinatarios;
            return destinatarios;
          }
          else throw new Error(response);
        })
      );
    }

  }

  getTipoMail(refresh?:boolean): Observable<TipoMail[]> {
    if(this.mails && !refresh){
      return of(this.mails)
    }else{
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.get(this.URL_GET_TIPO_MAILS, options).pipe(
      map((response: any) =>{
        if (response) {
          this.mails = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntrada(response)
          return this.mails;
        }
        else throw new Error(response);
      })
    );
    }
  }

  async getTipoEnvio(idTipoEnvio:string): Promise<TipoEnvio> {
    // await this.getTipoEnvios([],0,0)
    // this.envioObject = this.envios.find(x=> x.idTipoEnvio == idTipoEnvio)
    // return this.envioObject
    let id = `/${idTipoEnvio}`;
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return new Promise((resolve) => {
      this.client.get(this.URL_GET_TIPO_ENVIO_ID + id, options).pipe(
        map((response: any) =>{
          if (response) {
            let dosierId = this.conversionDatosApiService.mapEnviosEntrada([response]);
            let envioObjectArray = this.conversionDatosApiService.convertir0ANull(dosierId);

            envioObjectArray.forEach(x => {
              if(x.tiposDocumento.length == 0) x.activo = false;
              x.mailPrincipal = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(x.mailPrincipal);
              x.ordenMail = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(x.ordenMail);
              x.ordenTelefonoSMS = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(x.ordenTelefonoSMS);
              x.ordenTelefonoOTP = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(x.ordenTelefonoOTP);
              x.firmantes.map((y:any) => {
                y.tipoBusqueda = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(y.tipoBusqueda)
                y.tipoDestinatario = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(y.tipoDestinatario)
                y.tipoFirmante = this.conversionDatosApiService.mapTiposEnvioDesplegablesEntradaSingle(y.tipoFirmante)
              })
              //le damos el valor de mailPrincipal a ordenMail para salvar los dosieres angiguos que no tienen esta opción. Esto pasa en los creados antes de añadir el envío por SMS.

              if(x.mailPrincipal!==null && x.ordenMail==null) x.ordenMail=x.mailPrincipal;

              this.envioObject = x;
            })
            resolve(this.envioObject);
          }
          else throw new Error(response);
        })
      ).toPromise().catch(error => {
        console.log('error', error);
        throw error;
      });
    });
  }

  convertirAString(datos:any[]):any[]{
    datos.map(x => x.codigo = x.codigo.toString())
    return datos
  }
}
